// if document is changed then this function will be called to update the cart drawer 
function formatMoney(cents, format) {
  if (typeof cents == 'string') {
    cents = cents.replace('.', '');
  }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
    return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split('.'),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
      cents = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

const cartDrawer = document.querySelector('#cart-drawer');
const cartDrawerClose = document.querySelectorAll('#close-cart');
var loaderSkeleton = document.querySelector('.loader__skeleton');
const body = document.body;

// This function is used to fetch the cart drawer data from a end point i have created in the template with no layout containing the liquid code to append. 
async function refreshCartDrawer() {
loaderSkeleton.style.display = 'block';

  const response = await fetch('/?view=cart-drawer');
  const cartData = await response.text();

  const tempDiv = document.createElement('div');
  tempDiv.innerHTML = cartData;

  // Replace the cart drawer body content
  const cartDrawerBody = document.querySelector('.cart-drawer__body');
  cartDrawerBody.innerHTML = '';

  // Append everything except <script> tags
  Array.from(tempDiv.childNodes).forEach(node => {
    if (node.tagName !== 'SCRIPT') {
      cartDrawerBody.appendChild(node.cloneNode(true));
    }
  });

  // Extract and execute script tags manually
  const scriptTags = tempDiv.querySelectorAll('script');
  scriptTags.forEach(oldScript => {
    const newScript = document.createElement('script');
    if (oldScript.src) {
      // If it's an external script
      newScript.src = oldScript.src;
    } else {
      // If it's inline script
      newScript.textContent = oldScript.textContent;
    }
    document.body.appendChild(newScript); // or cartDrawerBody.appendChild if scoped
  });

  loaderSkeleton.style.display = 'none';

  const elementsToRemove = document.querySelectorAll('[data-rebuy-id="77545"]');
  elementsToRemove.forEach((element) => element.remove());

  const newDiv = document.createElement('div');
  newDiv.dataset.rebuyId = '77545';

  const cartContainers = document.querySelectorAll('.cart-drawer-upsell__container');
  if (!cartContainers.length) return;

  const lastCartContainer = cartContainers[cartContainers.length - 1];
  lastCartContainer.appendChild(newDiv);

  if (window.Rebuy) {
    Rebuy.init();
  }

  cartShippingThreshold();
}

document.addEventListener("rebuy:cart.change", function() { refreshCartDrawer(Rebuy.Cart.cart); });

async function toggleCartDrawer(isOpen) {
  const cartDrawer = document.querySelector('.cart-drawer');
  const cartDrawerOverlay = document.querySelector('.cart-drawer-overlay');
 
  if (isOpen) {
   
    setTimeout(() => {
      refreshCartDrawer();
      cartDrawer.style.transform = 'translateX(0)';
      cartDrawerOverlay.style.display = 'block';
      body.classList.add('cart-drawer-open');
      cartShippingThreshold();
    }, 1000);
  } else {
    cartDrawer.style.transform = 'translateX(100%)';
    cartDrawerOverlay.style.display = 'none';
    body.classList.remove('cart-drawer-open');
  }
}


const toggleCartDrawerButtons = document.querySelectorAll('[toggle-cart-drawer]');
toggleCartDrawerButtons.forEach((button) => {
  button.addEventListener('click', () => toggleCartDrawer(true));
});

const elementsToTriggerCartDrawer = '.addToCart, .button--pdp, .add-to-cart, .btn--submit, .quickAdd, .addtc-sticky-btn';
const elementsToTrigger = document.querySelectorAll(elementsToTriggerCartDrawer);
elementsToTrigger.forEach((element) => {
  element.addEventListener('click', () => {
      refreshCartDrawer();
      cartShippingThreshold();
      toggleCartDrawer(true);
  });
});

/// Function for close the cart drawer 
cartDrawerClose.forEach(function (button) {
  button.addEventListener('click', function () {
    cartDrawer.style.transform = 'translateX(100%)';
    document.querySelector('.cart-drawer-overlay').style.display = 'none';
    body.classList.remove('cart-drawer-open');
  });
});

// Close cart drawer when clicking outside the drawer (on body when cart-drawer-open class is present)
body.addEventListener('click', function (e) {
  // Only close if cart drawer is open and click is not on the cart drawer itself
  if (body.classList.contains('cart-drawer-open') && 
      !e.target.closest('.cart-drawer') && 
      !e.target.closest('[toggle-cart-drawer]') &&
      !e.target.closest('.addToCart, .button--pdp, .add-to-cart, .btn--submit, .quickAdd, .addtc-sticky-btn')) {
    cartDrawer.style.transform = 'translateX(100%)';
    document.querySelector('.cart-drawer-overlay').style.display = 'none';
    body.classList.remove('cart-drawer-open');
  }
});

/// Function on click to add upsell product to cart and call the addUpsellToCart function
document.querySelector('.cart-drawer__body').addEventListener('click', function (e) {
  if (e.target.id === 'upsell-add') {
    const upsellBtn = e.target;
    const upsellId = upsellBtn.getAttribute('upsell-id');
    addUpsellToCart(upsellBtn, upsellId);
  }
});

// This function is for updating the quantity for each item in the cart drawer, and it is then calling the updateQunaity function

document.querySelector('.cart-drawer__body').addEventListener('click', function (e) {
  if (e.target.classList.contains('cart-drawer-quantity__minus')) {
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) - 1;
    if (quantity >= 1) {
      updateCart(itemId, quantity, 'updateItemQty');
    }
  }
  if (e.target.classList.contains('cart-drawer-quantity__plus')) {
    const cartDrawerQuantityVal = e.target.parentElement.querySelector('.cart-drawer__item-quantity__val');
    const itemId = cartDrawerQuantityVal.getAttribute('data-item-id');
    const quantity = parseInt(cartDrawerQuantityVal.value, 10) + 1;
    updateCart(itemId, quantity, 'updateItemQty');
  }
  if (e.target.classList.contains('cart-drawer__item-delete')) {
    const itemId = e.target.getAttribute('data-item-id');
    updateCart(itemId, 0,'removeItem' )
  }

  if (e.target.classList.contains('smart-cart-drawer-upsell-product-add')) {
    e.preventDefault();
    const upsellBtn = e.target;
    const upsellId = upsellBtn.getAttribute('data-varaint');
    const quantity = 1;
    addToCart(upsellId, quantity);
  }
});

// this function handles the update item quanity as well as the remove item from the cart as it takes the type as a parameter
async function updateCart(itemId, quantity, type) {
  try {
    // Fetch the current cart
    const res = await fetch('/cart.js'); 
    const cart = await res.json(); 
    const item = cart.items.find((item) => (item.key == itemId));
    console.log(cart);
    // Check if the item is already at the desired quantity for update and return if true
    if (type === 'updateItemQty' && item.quantity === quantity) return;

    // Make a request to update or delete the item in the cart 
    let updatedRes;
    if (type === 'updateItemQty') {
       updatedRes = await fetch('/cart/change.js', {
         method: 'POST',
         headers: {
           'Content-Type': 'application/json'
         },
         body: JSON.stringify({
           id: itemId,
           quantity: quantity
         })
       });
    } else if (type === 'removeItem') {
       updatedRes = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: itemId,
          quantity: quantity
        })
       });
    }
    const updatedCart = await updatedRes.json();
    
    if (type === 'updateItemQty') {

        const updatedItem = updatedCart.items.find((item) => (item.key == itemId));
        const itemPrice = updatedItem.final_line_price;
        const moneyFormat = document.getElementById('cart-drawer').getAttribute('data-money-format');
        const cartDrawerSubtotalPrice = document.querySelector('.cart-drawer-subtotal__price');
        const cartDrawerItemPrice = document.querySelector(`[data-item-id="${itemId}"] .cart-drawer__item-price`);
        cartDrawerSubtotalPrice.innerHTML = formatMoney(updatedCart.total_price, moneyFormat);
        cartDrawerItemPrice.innerHTML = formatMoney(itemPrice, moneyFormat);

          refreshCartDrawer();

    } else if (type === 'removeItem') {
        loaderSkeleton.style.display = 'block';
        if (cart.items.length === 0) {
          cartDrawer.style.transform = 'translateX(100%)';
          document.querySelector('.cart-drawer-overlay').style.display = 'none';
          body.classList.remove('cart-drawer-open');
          document.querySelector('#cart-drawer__form').remove();
          const emptyState = document.createElement('div');
          emptyState.innerHTML = `
            <div class="cart-drawer__empty">
              <p class="cart-drawer__empty-text"> Your Basket is empty </p>
              <span> Add your favorite items to My Cart .</span>
              <a class="cart-drawer__empty-btn" href="/"> Shop Now <a>
            </div>`;
          document.querySelector('.cart-drawer .cart-drawer__body').appendChild(emptyState);
        } else {
          const removeItem = document.querySelector('.cart-drawer__item[data-item-id="' + itemId + '"]');
          loaderSkeleton.style.display = 'none';
          removeItem.remove();
          await refreshCartDrawer();
        }
      }
    jQuery.getJSON('/cart.js', function(cart) {
      $("span.cartCount").html("("+cart.item_count+")");
        var customerName = $("#cart-data").data("customer-name");
        if (customerName) {
            $("span.cartCount_drawer").html(customerName + "'s Cart <span>(" + cart.item_count + ")</span>");
        } else {
            $("span.cartCount_drawer").html("My Cart <span>(" + cart.item_count + ")</span>");
        }
          });
  } catch (error) {
    console.error('Error updating cart:', error);
  }
  cartShippingThreshold();
}


$('.shopify-product-form').on('submit', function(event) {
  event.preventDefault();
  var form = $(this);
  const selectElement = document.querySelector('.original-selector');
  const checkRechargeRadio = document.getElementById("rc-radio2")
  const qtyValue = 1;

  let sellingPlanId = '';
  const options = selectElement.options;
  for (let i = 0; i < options.length; i++) {
      if (options[i].selected) {
          selectedValue = options[i].value;
          sellingPlanId = options[i].getAttribute('selling-plan');
      }
  }
  if (checkRechargeRadio) {
    if (checkRechargeRadio.checked) {
      console.log('recharge');
      addToCart(selectedValue, qtyValue, sellingPlanId);
    } else {
      addToCart(selectedValue, qtyValue);
    }
  } else {
    addToCart(selectedValue, qtyValue);
  }
});



// Add product to cart function 
async function addToCart(id, quantity, sellingPlanAllocationId) {

  try{
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: id,
        quantity: quantity,
        selling_plan: sellingPlanAllocationId
      })
    });
   // IF RESPONSE IS 200 THEN SHOW THE CART DRAWER
    if (res.status === 200) {
      jQuery.getJSON('/cart.js', function(cart) {
      $("span.cartCount").html("("+cart.item_count+")");
        
    var customerName = $("#cart-data").data("customer-name");
    if (customerName) {
        $("span.cartCount_drawer").html(customerName + "'s Cart <span>(" + cart.item_count + ")</span>");
    } else {
        $("span.cartCount_drawer").html("My Cart <span>(" + cart.item_count + ")</span>");
    }
      });
    }

  }catch(err){
    console.log(err);

  }
}
  //get add to cart to work with collection page and its products. 
const tabCollectionContent = document.querySelector('.tab_collection_content');
if (tabCollectionContent) {
  tabCollectionContent.addEventListener('click', function (e) {
      if (e.target.classList.contains('btn--submit')) {
          e.preventDefault();
          const inputValue = e.target.parentElement.querySelector('#varaint-id__input').value;
          const inputQuantity = e.target.parentElement.querySelector('input').value;
          addToCart(inputValue, inputQuantity);
      }
  });
}

const bundleProduct = document.querySelectorAll('.product-bundle-submit');
if (bundleProduct) {
bundleProduct.forEach((product) => {
  product.addEventListener('click', function (e) {
    e.preventDefault();
    const input = e.target.parentElement.querySelector('#varaint-id__input');
    const inputValue = input ? input.value : null;
    const bundleQuantity = e.target.parentElement.querySelector('input').value;
    if (inputValue !== null) {
      addToCart(inputValue, bundleQuantity);
    }
  });
});
}
const quickAddCollection = document.querySelectorAll('.main-collection-quick-add');
if (quickAddCollection) {
  quickAddCollection.forEach((product) => {
    product.addEventListener('click', function (e) {
      if (e.target.classList.contains('quick-search')) {
        // Quick search button clicked, do nothing
        return;
      }
      else if (e.target.classList.contains('btn--submit')) {
        // Other button clicked, prevent default and call addToCart
        e.preventDefault();
        const input = e.target.parentElement.querySelector('#varaint-id__input');
        const inputValue = input ? input.value : null;
        const bundleQuantity = e.target.parentElement.querySelector('input').value;
        if (inputValue !== null) {
          addToCart(inputValue, bundleQuantity);
        }
      }
    });
  });
}
function cartShippingThreshold() {
  jQuery.getJSON('/cart.js', function(cart) {
    $("span.cartCount").html("(" + cart.item_count + ")");
    
    var customerName = $("#cart-data").data("customer-name");
    if (customerName) {
        $("span.cartCount_drawer").html(customerName + "'s Cart <span>(" + cart.item_count + ")</span>");
    } else {
        $("span.cartCount_drawer").html("My Cart <span>(" + cart.item_count + ")</span>");
    }
});
  // Carts subtotal
  var threadval = $(".cart-dawer__container").attr("data-free-shipping");
  var threadcont = $(".cart-dawer__container").attr("data-free-shippingval");
  
  setTimeout(function(){
  $('.cart-template__shipping-threshold-amount[data-free-shipping]').attr('data-free-shipping',threadval);
    $('.cart-template__shipping-threshold-amount[data-free-shipping]').html(threadcont);
  var cartSubtotal = document.querySelector('.carttotal .theme-money')?.textContent;
  cartSubtotal = cartSubtotal.split('$')[1];
  cartSubtotal.indexOf(',') ? cartSubtotal = cartSubtotal.split(',').join('') : '';

  // Shipping Threshold amount
  var shippingThreshold = document.querySelector('.cart-template__shipping-threshold-amount[data-free-shipping]').getAttribute('data-free-shipping');
  shippingThreshold.indexOf(',') ? shippingThreshold.split(',').join('') : '';

  // Amount away from Free Shipping
  var totalAway = shippingThreshold - cartSubtotal;

  // Progress bar width
  var progressBarWidth = ((cartSubtotal / shippingThreshold) * 100).toFixed();
  // We don't want the width to be more than 100%
  progressBarWidth > 100 ? progressBarWidth = 100 : '';
 
  // Progress bar
  var progressBar = document.querySelectorAll('.cart-template__shipping-threshold-bar-progress');
  for (i = 0; i < progressBar.length; i++) {
    progressBar[i].style = 'width: ' + progressBarWidth + '%';
  }

  // Threshold message
  var thresholdMessage = document.querySelectorAll('.cart-template__shipping-threshold-msg');
  var shipping_icon = $(".trs_wrapper svg");
  var congrat_icon = $(".trs_wrapper .congrat-img");
  for (i = 0; i < thresholdMessage.length; i++) {
    progressBarWidth === 100 ? thresholdMessage[i].innerHTML = 'Congrats! You\'ve reached <strong>Free shipping!</strong>' : thresholdMessage[i].innerHTML = 'You\'re only <strong>$' + totalAway.toFixed('2') + '</strong> away from <strong>Free shipping!</strong>';
    if (progressBarWidth === 100) {
      if (congrat_icon.length && shipping_icon.length) {
        shipping_icon.hide();
        congrat_icon.show();
      }
    } else {
      if (congrat_icon.length && shipping_icon.length) {
        shipping_icon.show();
        congrat_icon.hide();
      }
    }
  }

  // Line item shipping amount
  var lineItemMsg = document.querySelectorAll('.cart__details-shipping');
  for (i = 0; i < lineItemMsg.length; i++) {
    progressBarWidth === 100 ? lineItemMsg[i].innerHTML = '<span class="text--bright-green"><strong>Free</strong></span>' : '';
  }
  },2000);
}
